/* eslint-disable import/prefer-default-export */
export const EGestaoTarefasEtapa = {
  PENDENTE: 'pendente',
  ADMINISTRATIVO: 'administrativo',
  REGULATORIOCADASTRONOVOPRODUTO: 'regulatoriocadastronovoproduto',
  ACOMPANHAMENTO: 'acompanhamento',
  NACIONALIZACAO: 'nacionalizacao',
  FECHAMENTO: 'fechamento',
  CANCELAMENTOS: 'cancelamentos',
  CONCLUIDO: 'concluido',
};
